import { FintechPapiEmployee, ReportEmployeeData } from 'src/api/interfaces';
import { OrgChartEmployee } from '../types/orgChart.types';

export function transformToOrgChartEmployee(employee: FintechPapiEmployee): OrgChartEmployee {
  return {
    login: employee.basicInfo.login || '',
    firstName: employee.basicInfo.firstName || '',
    lastName: employee.basicInfo.lastName || '',
    email: employee.basicInfo.primaryEmail || '',
    jobTitle: employee.basicInfo.businessTitle || '',
    jobLevel: employee.job.jobLevel || '',
    city: employee.workLocation.city || '',
    country: employee.workLocation.country || '',
    department: employee.basicInfo.costCenterName || '',
    managerLogin: employee.basicInfo.managerLogin,
    directReports: (employee.directReports || []).map((dr) => dr.login).filter((login): login is string => !!login),
    badgeColor: employee.basicInfo.badgeColor
  };
}

export function transformFromReportData(report: ReportEmployeeData): Partial<OrgChartEmployee> {
  const nameParts = report.employee_name?.split(' ') || [];
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || '';

  return {
    login: report.login_name,
    firstName,
    lastName,
    email: report.employee_internal_email_address,
    jobTitle: report.job_title_name,
    jobLevel: report.job_level_name,
    city: report.location_city_name,
    country: report.location_state_name,
    department: report.department_name_current
  };
}

export function mergeEmployeeData(existing: OrgChartEmployee, partial: Partial<OrgChartEmployee>): OrgChartEmployee {
  return {
    ...existing,
    ...partial,
    directReports: partial.directReports ?? existing.directReports,
    login: partial.login || existing.login
  };
}

export function createMinimalEmployee(login: string): OrgChartEmployee {
  return {
    login,
    firstName: '',
    lastName: '',
    email: '',
    jobTitle: '',
    jobLevel: '',
    city: '',
    country: '',
    department: '',
    directReports: []
  };
}
